import type { HTMLAttributes, ReactNode } from "react";
import { injectCss } from "./injectCss";

const CSS = `
.js-stat{
  background:var(--surface-card);border:1px solid var(--border-subtle);
  border-radius:var(--radius-lg);box-shadow:var(--shadow-sm);
  padding:var(--space-5) var(--space-6);display:flex;flex-direction:column;gap:10px;
}
.js-stat__top{display:flex;align-items:center;justify-content:space-between;gap:12px}
.js-stat__label{font-size:var(--text-sm);color:var(--text-muted);font-weight:var(--weight-semibold);white-space:nowrap}
.js-stat__icon{
  width:36px;height:36px;border-radius:var(--radius-md);
  display:flex;align-items:center;justify-content:center;
  background:var(--brand-subtle);color:var(--brand);flex:none;
}
.js-stat__value{font-family:var(--font-num);font-weight:var(--weight-black);
  font-size:var(--text-display);line-height:1;color:var(--text-strong);font-variant-numeric:tabular-nums}
.js-stat__value small{font-size:var(--text-h3);font-weight:var(--weight-bold);color:var(--text-muted);margin-left:4px}
.js-stat__delta{display:inline-flex;align-items:center;gap:4px;font-size:var(--text-sm);font-weight:var(--weight-bold);font-variant-numeric:tabular-nums}
.js-stat__delta--up{color:var(--success-fg)}
.js-stat__delta--down{color:var(--danger-fg)}
.js-stat__delta--flat{color:var(--text-subtle)}
`;

export interface StatCardProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode;
  value: ReactNode;
  unit?: ReactNode;
  delta?: ReactNode;
  trend?: "up" | "down" | "flat";
  icon?: ReactNode;
  accent?: "brand" | "accent";
}

export function StatCard({
  label,
  value,
  unit,
  delta,
  trend = "flat",
  icon,
  accent,
  className = "",
  ...rest
}: StatCardProps) {
  injectCss("js-stat-css", CSS);
  const iconStyle =
    accent === "accent" ? { background: "var(--accent-subtle)", color: "var(--accent)" } : undefined;
  return (
    <div className={["js-stat", className].filter(Boolean).join(" ")} {...rest}>
      <div className="js-stat__top">
        <span className="js-stat__label">{label}</span>
        {icon && (
          <span className="js-stat__icon" style={iconStyle}>
            {icon}
          </span>
        )}
      </div>
      <div className="js-stat__value">
        {value}
        {unit && <small>{unit}</small>}
      </div>
      {delta != null && (
        <span className={`js-stat__delta js-stat__delta--${trend}`}>
          {trend === "up" ? "▲" : trend === "down" ? "▼" : "•"} {delta}
        </span>
      )}
    </div>
  );
}
